import { Injectable }    from '@angular/core';
import { Headers, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';
import {Observable} from 'rxjs/Rx';

import { Usuario } from '../usuarios/usuario';

import myGlobals = require('../config');

@Injectable()
export class MiCuentaService {

    private usuarioUrl = myGlobals.default.BASE_URL+'/miCuenta/';  // URL to web api

    constructor(private http: Http) { }


    save(usuario: Usuario): Observable<Usuario>  {
        if (usuario._id) {
            return this.put(usuario);
        }
    }

    // Actualizar usuario
    private put(usuario: Usuario) {
        let headers = new Headers();
        headers.append('Content-Type', 'application/json');

        let url = `${this.usuarioUrl}/${usuario._id}`;

        return this.http
            .put(url, JSON.stringify(usuario), {headers: headers})
            .map((response) => response.json());
    }

    cambiarPassword(usuario: Usuario): Observable<Usuario>  {
        let headers = new Headers();
        headers.append('Content-Type', 'application/json');

        let url = `${this.usuarioUrl}cambiarPassword/${usuario._id}`;

        return this.http
            .put(url, JSON.stringify(usuario), {headers: headers})
            .map((response) => response.json());
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/miCuenta/miCuenta.service.ts